import { Configurator } from './configurator';

export abstract class ConfiguratorConfigService {
    abstract configurator: (type: string, id: number, url?: string) => Configurator | Promise<Configurator>;
}
